import initmixin from "@/Services/initmixin";

export default {
  GET_DASHBOARD_INTELIGENTE: async function(data) {
    const params = new URLSearchParams({
      fechaInicio: data.fechaInicio,
      fechaFin: data.fechaFin,
      predicciones: data.predicciones || 'true',
      ia: data.ia || 'true'
    });
    let url = `/dashboard-inteligente/sistema-completo?${params.toString()}`;
    return initmixin.formatrespuesta('get', data, url, true);
  }
}
